import { render } from "./ActiveUsers.vue?vue&type=template&id=23846e50"
import script from "./ActiveUsers.vue?vue&type=script&lang=js"
export * from "./ActiveUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__